import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/' // 各领域有差异

/**
 * 存货项列表
 * @param {Object} params
 */
export const getStockList = params => axios({
  url: `${commonPath}stock/stock_list`,
  method: 'post',
  data: params
})

/**
 * 存货项详情
 * @param {String} id
 */
export const getStockInfo = id => axios({
  url: `${commonPath}stock/stock/${id}`,
  method: 'get'
})
